var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * CryptoKey interface
 */
var CryptoKey =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Constructor
   */
  function CryptoKey(_ref) {
    var type = _ref.type,
        extractable = _ref.extractable,
        algorithm = _ref.algorithm,
        usages = _ref.usages,
        handle = _ref.handle;

    _classCallCheck(this, CryptoKey);

    this.type = type;
    this.extractable = extractable;
    this.algorithm = algorithm;
    this.usages = usages; // ensure values are not writeable

    Object.defineProperties(this, {
      // TODO
      // These properties can't be fixed immediately on creation of the
      // object because the implementation may build it up in stages.
      // At some point in the operations before returning a key we should
      // freeze the object to prevent further manipulation.
      //type: {
      //  enumerable: true,
      //  writeable: false,
      //  value: type
      //},
      //extractable: {
      //  enumerable: true,
      //  writeable: true,
      //  value: extractable
      //},
      //algorithm: {
      //  enumerable: true,
      //  writeable: false,
      //  value: algorithm
      //},
      //usages: {
      //  enumerable: true,
      //  writeable: true,
      //  value: usages
      //},
      // this is the "key material" used internally
      // it is not enumerable, but we need it to be
      // accessible by algorithm implementations
      handle: {
        enumerable: false,
        writeable: false,
        value: handle
      }
    }); //if (!Array.isArray(type) || KeyType.indexOf(type) === -1) { throw new Error('Invalid CryptoKey type') }
    // verify type of algorithm
    // verify type/enum of usages
  }
  /**
   * Structured clone algorithm
   * https://www.w3.org/TR/WebCryptoAPI/#cryptokey-interface-clone
   *
   * TODO
   * This requires review and consideration with respect to the
   * internal structured cloning algorithm.
   * https://www.w3.org/TR/WebCryptoAPI/#dfn-structured-clone
   *
   * @param {Object} input
   * @param {Object} memory
   *
   * @returns {CryptoKey}
   */


  _createClass(CryptoKey, [{
    key: "clone",
    value: function clone(_ref2, memory) {
      var type = _ref2.type,
          extractable = _ref2.extractable,
          algorithm = _ref2.algorithm,
          usages = _ref2.usages,
          handle = _ref2.handle;
      return new CryptoKey({
        type: type,
        extractable: extractable,
        algorithm: algorithm,
        usages: usages,
        handle: handle
      });
    }
  }]);

  return CryptoKey;
}();
/**
 * Export
 */


module.exports = CryptoKey;